import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import Button from '../Button';
import { Sizes as ButtonSizes } from '../Button/Button';

class ButtonsGroup extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      values: props.values,
    };

    this.buttonsEls = [];
    this.el = React.createRef();

    this.handleClick = this.handleClick.bind(this);
    this.handleButtonsRefs = this.handleButtonsRefs.bind(this);
  }

  setValue(value) {
    const { values } = this.state;
    const { required } = this.props;

    let nextValues;
    if (values.includes(value)) {
      nextValues = _.without(values, value);
    } else {
      nextValues = values.concat(value);
    }

    if (!required || !_.isEmpty(nextValues)) {
      this.setState(
        {
          values: nextValues,
        },
        this.dispatchChangeEvent
      );
    }
  }

  handleButtonsRefs(component) {
    const element = ReactDOM.findDOMNode(component);
    this.buttonsEls.push(element);
  }

  handleClick(ev) {
    ev.stopPropagation();
    const { target } = ev;
    const clickedElement = this.buttonsEls.find(buttonEl =>
      buttonEl?.contains(target)
    );

    if (!clickedElement) return;

    const { value } = clickedElement;
    this.setValue(value);
  }

  dispatchChangeEvent() {
    const { onChange } = this.props;
    const { values } = this.state;
    const event = new CustomEvent('change', {
      bubbles: true,
      detail: {
        value: values,
      },
    });

    this.el.current.dispatchEvent(event);
    onChange(event);
  }

  render() {
    const { children, ...props } = this.props;
    const { values } = this.state;

    return (
      <StyledButtonsGroup {...props} ref={this.el}>
        {React.Children.map(children, (child, index) => {
          const { value } = child.props;
          const isChecked = values && values.includes(value);

          return (
            <StyledButton
              data-index={index}
              component={child}
              checked={isChecked}
              onClick={this.handleClick}
              ref={this.handleButtonsRefs}
            />
          );
        })}
      </StyledButtonsGroup>
    );
  }
}

ButtonsGroup.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf([Button]),
    }).isRequired
  ).isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  values: PropTypes.arrayOf(PropTypes.string.isRequired),
};

ButtonsGroup.defaultProps = {
  className: '',
  onChange: Function.prototype,
  values: null,
  required: false,
};

const StyledButton = styled(
  React.forwardRef((props, ref) => {
    const { component, ...restProps } = props;

    return React.cloneElement(component, {
      ...restProps,
      ref,
      size: ButtonSizes.FLEX,
    });
  })
)`
  background-color: #e6e6e6;
  border-radius: 84px;
  height: 36px;
  line-height: 34px;
  min-height: initial;
  overflow: hidden;
  padding: 0 12px;

  :hover {
    border-color: #007aff;
    color: #007aff;
  }

  ${props =>
    props.checked &&
    `
    background-color: #fff;
    border-color: #fff;
    color: #17181a;
    
    :hover {
      border-color: #fff;
      color: #17181a;
    }
  `}
`;

const StyledButtonsGroup = styled.div`
  > ${StyledButton} + ${StyledButton} {
    margin-left: 10px;
  }
`;

ButtonsGroup.StyledButton = StyledButton;
export default ButtonsGroup;
